import React, { Component, useState } from "react";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import {
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@material-ui/core";
import { Col, Row, Image, InputGroup } from "react-bootstrap";

import Dialog from "@material-ui/core/Dialog";

import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import Alert from "react-s-alert";

const state = {
  taxSurchargesArr: [],
};
const VALUE = (
  <i className="fa fa-VALUE" aria-hidden="true">
    ₹
  </i>
);

const INR = <i className="fa fa-inr" aria-hidden="true"></i>;
const TaxesSurCharges = (props) => {
  const [showTaxSurcharges, setshowTaxSurcharges] = useState(true);
  const [edit, setEdit] = React.useState(props.origin ? false : true);

  const handleShowTaxSurcharges = () => {
    setshowTaxSurcharges(!showTaxSurcharges);
  };
  const onEditTaxAndSurcharges = () => setEdit(!edit);
  const [state, setState] = React.useState({
    id: "Id",
    tax_name: "tax_name",
    take_away: 100,
    tax_value: "PERCENTAGE",
    curb_side: 150,
    dine_in_order: 110,
    catering_banquet: 40,
    home_delivery: 70,
  });
  const changeHandle = (e) => {
    setState({
      ...state,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <React.Fragment>
      {showTaxSurcharges && (
        <React.Fragment>
          <Row className={"align-items-center pb-4"}>
            {!props.origin && (
              <Col md={3} xs={12} className="mb-2">
                <div className="f12-500">{props.tax_name}</div>
              </Col>
            )}

            <Col
              md={!props.origin ? 6 : 12}
              xs={!props.origin ? 10 : 12}
              className="p-0"
            >
              <div className="enGrayBorderBox p-3">
                {props.orderingData &&
                props.orderingData.take_away &&
                props.orderingData.take_away.value ? (
                  <div className="d-flex justify-content-between pb-3 align-items-center">
                    <div className="f14-500">Take Away</div>
                    <div>
                      <InputGroup className="enInputwithText border-0 rounded-0">
                        <input
                          type="number"
                          value={props.take_away}
                          name="take_away"
                          onChange={(e) =>
                            props.changeHandle(e.target.value, "take_away")
                          }
                          disabled={edit}
                        />
                        <InputGroup.Prepend>
                          <InputGroup.Text className="border-0 rounded-0">
                            {props.tax_value === "PERCENTAGE"
                              ? "%"
                              : props.tax_value === "VALUE"
                              ? VALUE
                              : null}
                          </InputGroup.Text>
                        </InputGroup.Prepend>
                      </InputGroup>
                    </div>
                  </div>
                ) : null}
                {props.orderingData &&
                props.orderingData.curb_side &&
                props.orderingData.curb_side.value ? (
                  <div className="d-flex justify-content-between pb-3 align-items-center">
                    <div className="f14-500">Curb Side</div>
                    <div>
                      <InputGroup className="enInputwithText border-0 rounded-0">
                        <input
                          type="number"
                          value={props.curb_side}
                          name="curb_side"
                          onChange={(e) =>
                            props.changeHandle(e.target.value, "curb_side")
                          }
                          disabled={edit}
                        />
                        <InputGroup.Prepend>
                          <InputGroup.Text className="border-0 rounded-0">
                            {props.tax_value === "PERCENTAGE"
                              ? "%"
                              : props.tax_value === "VALUE"
                              ? VALUE
                              : null}
                          </InputGroup.Text>
                        </InputGroup.Prepend>
                      </InputGroup>
                    </div>
                  </div>
                ) : null}

                {props.orderingData &&
                props.orderingData.skip_line &&
                props.orderingData.skip_line.value ? (
                  <div className="d-flex justify-content-between pb-3 align-items-center">
                    <div className="f14-500">Skip the line </div>
                    <div
                    // style={{ width: !props.origin && "44%" }}
                    >
                      <InputGroup className="enInputwithText border-0 rounded-0">
                        <input
                          type="number"
                          value={props.skip_line}
                          disabled={edit}
                          name="skip_line"
                          onChange={(e) =>
                            props.changeHandle(e.target.value, "skip_line")
                          }
                        />
                        <InputGroup.Prepend>
                          <InputGroup.Text className="border-0 rounded-0">
                            {props.tax_value === "PERCENTAGE"
                              ? "%"
                              : props.tax_value === "VALUE"
                              ? VALUE
                              : null}
                          </InputGroup.Text>
                        </InputGroup.Prepend>
                      </InputGroup>
                    </div>
                  </div>
                ) : null}
                {props.orderingData &&
                props.orderingData.dine_in_order &&
                props.orderingData.dine_in_order.value ? (
                  <div className="d-flex justify-content-between pb-3 align-items-center">
                    <div className="f14-500">
                      Dine-In / <br />
                      Order Ahead
                    </div>
                    <div>
                      <InputGroup className="enInputwithText border-0 rounded-0">
                        <input
                          type="number"
                          value={props.dine_in_order}
                          disabled={edit}
                          name="dine_in_order"
                          onChange={(e) =>
                            props.changeHandle(e.target.value, "dine_in_order")
                          }
                        />
                        <InputGroup.Prepend>
                          <InputGroup.Text className="border-0 rounded-0">
                            {props.tax_value === "PERCENTAGE"
                              ? "%"
                              : props.tax_value === "VALUE"
                              ? VALUE
                              : null}
                          </InputGroup.Text>
                        </InputGroup.Prepend>
                      </InputGroup>
                    </div>
                  </div>
                ) : null}
                {props.orderingData &&
                props.orderingData.catering_banquet &&
                props.orderingData.catering_banquet.value ? (
                  <div className="d-flex justify-content-between pb-3 align-items-center">
                    <div className="f14-500">Catering and Banquet</div>
                    <div
                    //  style={{ width: !props.origin && "44%" }}
                    >
                      <InputGroup className="enInputwithText border-0 rounded-0">
                        <input
                          type="number"
                          value={props.catering_banquet}
                          disabled={edit}
                          name="catering_banquet"
                          onChange={(e) =>
                            props.changeHandle(
                              e.target.value,
                              "catering_banquet"
                            )
                          }
                        />
                        <InputGroup.Prepend>
                          <InputGroup.Text className="border-0 rounded-0">
                            {props.tax_value === "PERCENTAGE"
                              ? "%"
                              : props.tax_value === "VALUE"
                              ? VALUE
                              : null}
                          </InputGroup.Text>
                        </InputGroup.Prepend>
                      </InputGroup>
                    </div>
                  </div>
                ) : null}
                {props.orderingData &&
                props.orderingData.home_delivery &&
                props.orderingData.home_delivery.value ? (
                  <div className="d-flex justify-content-between pb-3 align-items-center">
                    <div className="f14-500">Home Delivery</div>
                    <div>
                      <InputGroup className="enInputwithText border-0 rounded-0">
                        <input
                          type="number"
                          value={props.home_delivery}
                          disabled={edit}
                          name="home_delivery"
                          onChange={(e) =>
                            props.changeHandle(e.target.value, "home_delivery")
                          }
                        />
                        <InputGroup.Prepend>
                          <InputGroup.Text className="border-0 rounded-0">
                            {props.tax_value === "PERCENTAGE"
                              ? "%"
                              : props.tax_value === "VALUE"
                              ? VALUE
                              : null}
                          </InputGroup.Text>
                        </InputGroup.Prepend>
                      </InputGroup>
                    </div>
                  </div>
                ) : null}
                {props.origin && (
                  <div className="d-flex justify-content-end">
                    <button
                      className="mr-3 btn-sm btn btn-outline-secondary"
                      onClick={() => props.handleClose()}
                    >
                      Cancel
                    </button>
                    <button
                      onClick={() => props.onSave()}
                      className="btn btn-danger btn-sm ml-3"
                    >
                      Save
                    </button>
                  </div>
                )}
              </div>
            </Col>
            {!props.origin && (
              <Col md={3} xs={2}>
                <div className="f12-400 pb-4">Action</div>
                <div className="d-flex">
                  <IconButton
                    className="mr-4 p-0"
                    onClick={(e) => onEditTaxAndSurcharges(state.id)}
                  >
                    <Image
                      src={require("../../../../../../../assets/images/UserManagement/editBlue.svg")}
                      alt="edit taxes"
                      title="edit taxes"
                      className="w-20px"
                    />
                  </IconButton>
                  <IconButton
                    className="p-0"
                    onClick={() => props.removeTax()}
                    //   onClick={(e) => removeAddTaxSurcharges(data.id)}
                  >
                    <Image
                      src={require("../../../../../../../assets/images/UserManagement/delete-gray.svg")}
                      alt="delete tax"
                      title="delete tax"
                      className="w-20px"
                    />
                  </IconButton>
                </div>
              </Col>
            )}
          </Row>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default TaxesSurCharges;

export const AddSurchargesModel = (props) => {
  const [open, setOpen] = React.useState(!props.open);

  const [modalValues, setModalValues] = useState({
    id: "",
    tax_name: "",
    tax_value: "PERCENTAGE",
    code: "",
    take_away: 0,
    curb_side: 0,
    dine_in_order: 0,
    skip_line: 0,
    catering_banquet: 0,
    home_delivery: 0,
  });

  const onChangeSelectedTax = (e) => {
    for (let i = 0; i < props.taxInfo.length; i++) {
      if (e.target.value === props.taxInfo[i].id) {
        setModalValues({
          ...modalValues,
          id: e.target.value,
          tax_name: props.taxInfo[i].tax_name,
          code: props.taxInfo[i].code,
        });
        break;
      }
    }
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const modalData = (e, name) => {
    let existingData = JSON.parse(JSON.stringify(modalValues));
    existingData[name] = e;
    setModalValues(existingData);
  };

  const onClickSave = () => {
    if (modalValues.id === "") {
      Alert.error(`<h4> Please select tax</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    } else {
      props.onClickSaveModalData(modalValues);
      handleClose();
    }
  };
  React.useEffect(() => {
    setOpen(props.open);
  }, [props.open]);
  const handleClose = () => {
    props.closeAddSurcharges();
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        size={"lg"}
        fullWidth
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <div>
              <Row>
                <Col sm={4}>
                  <div className="f14-700 mb-2">
                    Maintain Tax/ Surcharges for Order Types
                  </div>
                  <div className="f12-400 mb-2" style={{ color: "#9E9E9E" }}>
                    Order Types Below will be listed based on your subscriptions
                    enabled
                  </div>
                </Col>
                <Col sm={8} className="mb-1">
                  <div>
                    <FormControl variant="outlined" fullWidth>
                      <InputLabel id="demo-simple-select-outlined-label">
                        Description of Tax Category
                      </InputLabel>
                      <Select
                        value={modalValues.id}
                        labelId="demo-simple-select-outlined-label"
                        id="demo-simple-select-outlined"
                        onChange={(e) => onChangeSelectedTax(e)}
                        // value={age}
                        // onChange={handleChange}
                        label="Description of Tax Category"
                      >
                        {/* <MenuItem value="">
                          <em>None</em>
                        </MenuItem> */}
                        {/* <MenuItem value={10}>Ten</MenuItem>
                        <MenuItem value={20}>Twenty</MenuItem>
                        <MenuItem value={30}>Thirty</MenuItem> */}
                        {/* {console.log(props.taxInfo)} */}
                        {props.taxInfo &&
                          props.taxInfo.map((item, index) => (
                            <MenuItem
                              key={index}
                              name={item.tax_name}
                              value={item.id}
                            >
                              {item.tax_name}
                            </MenuItem>
                          ))}
                      </Select>
                    </FormControl>
                    <div className="d-flex justify-content-end pb-3 mt-1">
                      <div className="btnGroup2">
                        <button
                          type="button"
                          onClick={() => {
                            setModalValues({
                              ...modalValues,
                              tax_value: "PERCENTAGE",
                            });
                          }}
                          className={`${
                            modalValues.tax_value === "PERCENTAGE"
                              ? "active"
                              : ""
                          }`}
                        >
                          %
                        </button>
                        <button
                          type="button"
                          onClick={() => {
                            setModalValues({
                              ...modalValues,
                              tax_value: "VALUE",
                            });
                          }}
                          className={`${
                            modalValues.tax_value === "VALUE" ? "active" : ""
                          }`}
                        >
                          {INR}
                        </button>
                      </div>
                    </div>

                    <TaxesSurCharges
                      changeHandle={modalData}
                      origin={"popup"}
                      tax_value={modalValues.tax_value}
                      take_away={modalValues.take_away}
                      curb_side={modalValues.curb_side}
                      dine_in_order={modalValues.dine_in_order}
                      skip_line={modalValues.skip_line}
                      catering_banquet={modalValues.catering_banquet}
                      home_delivery={modalValues.home_delivery}
                      onSave={onClickSave}
                      handleClose={handleClose}
                      orderingData={{
                        skip_line: { value: props.skip_line },
                        take_away: { value: props.take_away },
                        curb_side: { value: props.curb_side },
                        dine_in_order: { value: props.dine_in_order },
                        catering_banquet: { value: props.catering_banquet },
                        home_delivery: { value: props.home_delivery },
                      }}
                    />
                  </div>
                </Col>
              </Row>
            </div>
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export const TaxesServices = (props) => {
  const [showTaxSurcharges, setshowTaxSurcharges] = useState(true);
  const [edit, setEdit] = React.useState(true);
  const handleShowTaxSurcharges = () => {
    setshowTaxSurcharges(!showTaxSurcharges);
  };
  const onEditTaxAndSurcharges = () => setEdit(!edit);
  const [state, setState] = React.useState({
    id: "Id",
    tax_name: "tax_name",
    take_away: 100,
    tax_value: "PERCENTAGE",
    curb_side: 150,
    dine_in_order: 110,
    catering_banquet: 40,
    home_delivery: 70,
    skip_line: 10,
  });

  return (
    <React.Fragment>
      {showTaxSurcharges && (
        <React.Fragment>
          <Row className={"align-items-center pb-4"}>
            {!props.origin && (
              <Col md={3} xs={12} className="mb-2">
                <div className="f12-500">{props.tax_name}</div>
              </Col>
            )}
            <Col md={!props.origin ? 6 : 12} xs={!props.origin ? 10 : 12}>
              <div className="enGrayBorderBox p-3">
                {props.orderingData &&
                props.orderingData.take_away &&
                props.orderingData.take_away.value ? (
                  <div className="d-flex justify-content-between pb-3 align-items-center">
                    <div className="f14-500">{props.service_name}</div>
                    <div>
                      <InputGroup className="enInputwithText border-0 rounded-0">
                        <input
                          type="number"
                          value={props.take_away}
                          name="take_away"
                          onChange={(e) => props.changeHandle(e.target.value)}
                          disabled={edit}
                        />
                        <InputGroup.Prepend>
                          <InputGroup.Text className="border-0 rounded-0">
                            {props.tax_value === "PERCENTAGE"
                              ? "%"
                              : props.tax_value === "VALUE"
                              ? VALUE
                              : null}
                          </InputGroup.Text>
                        </InputGroup.Prepend>
                      </InputGroup>
                    </div>
                  </div>
                ) : null}

                {props.origin && (
                  <div className="d-flex justify-content-end">
                    <button className="mr-3 btn-sm btn btn-outline-secondary">
                      Cancel
                    </button>
                    <button className="btn btn-danger btn-sm ml-3">Save</button>
                  </div>
                )}
              </div>
            </Col>
            {!props.origin && (
              <Col md={3} xs={2}>
                <div className="f12-400 pb-4">Action</div>
                <div className="d-flex">
                  {!props?.noEdit && 
                    <IconButton
                      className="mr-4 p-0"
                      onClick={(e) => onEditTaxAndSurcharges(state.id)}
                    >
                      <Image
                        src={require("../../../../../../../assets/images/UserManagement/editBlue.svg")}
                        alt="edit tax"
                        title="edit tax"
                        className="w-20px"
                      />
                    </IconButton>
                  }
                  <IconButton
                    className="p-0"
                    onClick={props.removeTax}
                    //   onClick={(e) => removeAddTaxSurcharges(data.id)}
                  >
                    <Image
                      src={require("../../../../../../../assets/images/UserManagement/delete-gray.svg")}
                      alt="delete tax"
                      title="delete tax"
                      className="w-20px"
                    />
                  </IconButton>
                </div>
              </Col>
            )}
          </Row>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};
